/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Unrealenginetitle2Inputs */

const id_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const ms_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const da_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const de_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const en_us2_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const es_es2_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const es_mx2_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const fil_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const fr_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const it_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const hu_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const nl_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const no_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const pl_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const pt_br2_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const pt_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const ro_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const fi_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const sv_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const vi_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const tr_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const cs_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const bg_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const ru_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const uk_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const ar_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const hi_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनरियल इंजन`)
};

const th_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const ja_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const zh_cn2_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`虚幻引擎`)
};

const zh_hant1_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`虛幻引擎`)
};

const ko_sandboxes_unrealenginetitle2 = /** @type {(inputs: Sandboxes_Unrealenginetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

/**
* | output |
* | --- |
* | "Unreal Engine" |
*
* @param {Sandboxes_Unrealenginetitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_unrealenginetitle2 = /** @type {((inputs?: Sandboxes_Unrealenginetitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Unrealenginetitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_unrealenginetitle2(inputs)
	if (locale === "ms") return ms_sandboxes_unrealenginetitle2(inputs)
	if (locale === "da") return da_sandboxes_unrealenginetitle2(inputs)
	if (locale === "de") return de_sandboxes_unrealenginetitle2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_unrealenginetitle2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_unrealenginetitle2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_unrealenginetitle2(inputs)
	if (locale === "fil") return fil_sandboxes_unrealenginetitle2(inputs)
	if (locale === "fr") return fr_sandboxes_unrealenginetitle2(inputs)
	if (locale === "it") return it_sandboxes_unrealenginetitle2(inputs)
	if (locale === "hu") return hu_sandboxes_unrealenginetitle2(inputs)
	if (locale === "nl") return nl_sandboxes_unrealenginetitle2(inputs)
	if (locale === "no") return no_sandboxes_unrealenginetitle2(inputs)
	if (locale === "pl") return pl_sandboxes_unrealenginetitle2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_unrealenginetitle2(inputs)
	if (locale === "pt") return pt_sandboxes_unrealenginetitle2(inputs)
	if (locale === "ro") return ro_sandboxes_unrealenginetitle2(inputs)
	if (locale === "fi") return fi_sandboxes_unrealenginetitle2(inputs)
	if (locale === "sv") return sv_sandboxes_unrealenginetitle2(inputs)
	if (locale === "vi") return vi_sandboxes_unrealenginetitle2(inputs)
	if (locale === "tr") return tr_sandboxes_unrealenginetitle2(inputs)
	if (locale === "cs") return cs_sandboxes_unrealenginetitle2(inputs)
	if (locale === "bg") return bg_sandboxes_unrealenginetitle2(inputs)
	if (locale === "ru") return ru_sandboxes_unrealenginetitle2(inputs)
	if (locale === "uk") return uk_sandboxes_unrealenginetitle2(inputs)
	if (locale === "ar") return ar_sandboxes_unrealenginetitle2(inputs)
	if (locale === "hi") return hi_sandboxes_unrealenginetitle2(inputs)
	if (locale === "th") return th_sandboxes_unrealenginetitle2(inputs)
	if (locale === "ja") return ja_sandboxes_unrealenginetitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_unrealenginetitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_unrealenginetitle2(inputs)
	return ko_sandboxes_unrealenginetitle2(inputs)
});
export { sandboxes_unrealenginetitle2 as "sandboxes.unrealEngineTitle" }